module.exports = __webpack_public_path__ + "img/oakchevron913m_detail_rsh2.2ee9466d.jpg";